import { useState } from 'react';
import {
    headerNotificationKeys,
    notificationTranslations,
    routeNotifications
} from './notificationTranslations.generated';
import { notificationsForRoute } from './notificationsForRoute';

export function useNotificationPreviews(pathname: string) {
    const [showAll, setShowAll] = useState(false);
    const forRoute = notificationsForRoute(
        pathname,
        notificationTranslations,
        headerNotificationKeys,
        routeNotifications
    );

    return {
        entries: showAll ? notificationTranslations : forRoute.entries,
        scopedToRoute: forRoute.scopedToRoute && !showAll,
        canScopeToRoute: forRoute.scopedToRoute,
        showAll,
        setShowAll
    };
}
